// libraries.
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store';

// interfaces.
import type { InvalidPolygon } from '../api-slices/auditPolygons.endpoints';

export interface AuditPolygonsState {
  // Si el usuario ya disparó la auditoría al menos una vez. Se persiste en el
  // store (no en el componente) para que la lista no se pierda al cambiar de
  // tab y volver.
  requested: boolean;
  // Polígono inválido seleccionado en la lista; se dibuja directo en el mapa
  // desde sus coordenadas (independiente de la query de la zona).
  selected: InvalidPolygon | null;
}

export const initialState: AuditPolygonsState = {
  requested: false,
  selected: null,
};

export const domainAuditPolygonsSlice = createSlice({
  name: 'domainAuditPolygons',
  initialState,
  reducers: {
    setAuditRequested: (state, action: PayloadAction<boolean>) => {
      state.requested = action.payload;
    },
    setSelectedAuditPolygon: (
      state,
      action: PayloadAction<InvalidPolygon | null>
    ) => {
      state.selected = action.payload;
    },
  },
});

export const { setAuditRequested, setSelectedAuditPolygon } =
  domainAuditPolygonsSlice.actions;

export default domainAuditPolygonsSlice.reducer;

// selectors.
export const getAuditRequested = (state: RootState) =>
  state.domainAuditPolygons.requested;

export const getSelectedAuditPolygon = (state: RootState) =>
  state.domainAuditPolygons.selected;
